import {FunctionComponent, HTMLAttributes, useState} from 'react';
import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';
import useOnClickOutside from '@/hooks/use-on-click-outside';

type Props = HTMLAttributes<HTMLDivElement> & {
  clickOutsideElement?: HTMLElement | null;
  onClose: () => void;
  shouldCloseOnClickOutside?: boolean;
  toggleRef?: React.RefObject<HTMLButtonElement | null>;
};

const PopupMenu: FunctionComponent<Props> = ({
  children,
  className,
  clickOutsideElement,
  onClose,
  shouldCloseOnClickOutside = true,
  toggleRef,
  ...props
}) => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  const mergedClasses = clsx(
    'absolute top-full z-30 min-w-96 animate-slideFadeIn rounded-4 border border-greige-925 bg-white p-6 shadow',
    className,
  );

  useOnClickOutside(clickOutsideElement || container, onClose, {
    enabled: shouldCloseOnClickOutside,
    preventOn: toggleRef as React.RefObject<HTMLButtonElement> | undefined,
  });

  return (
    <div
      className={twMerge(mergedClasses)}
      role="dialog"
      ref={setContainer}
      data-testid="menu-sections-list"
      {...props}
    >
      {children}
    </div>
  );
};

export default PopupMenu;
